<template>
  <material-card
    :title="$t('views.members.members_files')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="contact_page"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <pbas-data-table
      ref="table"
      :exporters="$exporters"
      :dataProvider="provider"
      :selectAll="true"
      :showSelect="true"
      :selectActions="selectActions"
      :rowActions="rowActions"
      fileNamePrefix="files"
      @itemsChanged="setData($event)"
      identifier="membersFiles"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="loadingFile" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-if="selectedPlan"
      v-model="shareDialog"
      persistent
      max-width="900"
    >
      <share-member-files
        v-if="shareDialog"
        :brokerId="selectedPlan.BrokerId"
        :planId="selectedPlan.Id"
        @closeDialog="(e) => (shareDialog = e)"
        :files="checkedFiles"
        :maxDataRetrieved="10"
      />
    </v-dialog>

    <v-dialog
      scrollable
      v-if="selectedItem && selectedItem.FileSegments"
      v-model="viewFilesDialog"
      persistent
      max-width="900"
    >
      <material-card
        icon="mdi-file-eye-outline"
        :color="$vuetify.theme.themes.light.secondary"
        :title="$t('filebrowser.filedetails.file_details')"
      >
        <v-card-text>
          <v-container class="overflow-y-auto">
            <v-row
              v-for="file in selectedItem.FileSegments"
              :key="file.PhysicalFileId"
            >
              <member-file-details
                :memberIdentity="selectedItem.MemberIdentity"
                :file="file"
                :createdBy="selectedItem.CreatedBy"
                @closeDialog="
                  (e) => {
                    fileDetails = e;
                  }
                "
              />
              <v-divider />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="viewFilesDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog scrollable v-model="deleteDialog" persistent max-width="500">
      <material-card
        v-if="checkedFiles"
        :title="$t('filebrowser.deletefiles.title')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false" :loading="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="deleteItems" :loading="saving">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <file-preview
      :fullScreen="true"
      v-if="viewDialog"
      :view="viewDialog"
      :fileItem="fileItem"
      @close="
        viewDialog = false;
        fileItem = null;
      "
    />
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
import { saveAs } from "file-saver";
import { base64ToArrayBuffer } from "../utils/file.js";
import ShareMemberFiles from "../components/ShareMemberFiles.vue";
import MemberFileDetails from "../components/MemberFileDetails.vue";
import MemberFilesHeaders from "../headers/MemberFiles";
import { mapFileSegmentIds } from "../makeMemberFile";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "../trans2";
import FilePreview from "../components/FilePreview.vue";

export default {
  name: "members-download-table",
  components: {
    ErrorHandler,
    ShareMemberFiles,
    MemberFileDetails,
    FilePreview,
  },
  mixins: [planSetter],
  data() {
    return {
      branchHeader: new ODataHeader({
        title: "headers.member_files.branch",
        type: new ODataString(
          "MemberIdentity/CurrentEmploymentInformation/Store/Current/Translations[]/Name",
          {
            getString: (item) => {
              if (
                !item ||
                !item.MemberIdentity ||
                !item.MemberIdentity.CurrentEmploymentInformation ||
                !item.MemberIdentity.CurrentEmploymentInformation.Store
              ) {
                return "";
              }
              return translate2(
                item.MemberIdentity.CurrentEmploymentInformation.Store.Current,
                "Name"
              );
            },
          }
        ),
      }),
      loadingFile: false,
      files: null,
      checkedFiles: null,
      provider: undefined,
      shareDialog: false,
      deleteDialog: false,
      viewFilesDialog: false,
      viewDialog: false,
      error: null,
      startingCategories: [],
      startingTags: [],
      allFoldersAsTree: [],
      allFoldersAsList: [],
      ownedTags: null,
      notOwnedTags: null,
      ownedCategories: null,
      notOwnedCategories: null,
      rowActions: [
        {
          name: "view",
          icon: "visibility",
          title: "globals.view",
          handler: (item) => {
            console.log(item);
            this.fileItem = item.FileSegments[0];
            this.fileItem.Id = item.FileSegments[0].PhysicalFileId;
            this.viewDialog = true;
          },
          visible: (item) => {
            return (
              (item.FileSegments.length === 1 &&
                item.FileSegments[0].FileType === "Adobe Reader") ||
              item.FileSegments[0].FileType === "Image" ||
              item.FileSegments[0].FileType === "text"
            );
          },
        },
        {
          name: "previewItem",
          icon: "mdi-file-eye-outline",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.selectedItem = item;
            this.viewFilesDialog = true;
          },
        },
        {
          name: "downloadFiles",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            this.checkedFiles = [];
            this.checkedFiles.push(item);
            this.downloadFiles();
          },
        },
        {
          name: "shareFile",
          icon: "share",
          title: "globals.share",
          handler: (item) => {
            this.checkedFiles = [];
            this.checkedFiles.push(item);
            this.shareDialog = true;
          },
        },
        {
          name: "deleteFiles",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.checkedFiles = [];
            this.checkedFiles.push(item);
            this.deleteDialog = true;
          },
        },
      ],
      selectActions: [
        {
          name: "downloadFiles",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            this.checkedFiles = item;
            this.downloadFiles();
          },
        },
        {
          name: "shareFile",
          icon: "share",
          title: "globals.share",
          handler: (item) => {
            this.checkedFiles = item;
            this.shareDialog = true;
          },
        },
        {
          name: "deleteFiles",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.checkedFiles = item;
            this.deleteDialog = true;
          },
        },
      ],
      tableTitle: "Members Files",
      confirmDeleteDialog: false,
      selectedItem: null,
      headers: MemberFilesHeaders,
      saving: false,
      fileItem: null,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["planIdentity", "planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        console.log("coverage: selectedPlan changed");
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("documentsService", ["downloadFile"]),
    ...mapActions("plansMembers", ["deleteMemberFiles"]),
    setData(items) {
      this.files = items;
    },
    loadPlanData() {
      let headers = this.headers.concat([]);
      if (this.planOptions.HasStores) {
        headers = this.headers.concat([this.branchHeader]);
      }
      this.provider = new PbasOData(
        this.$axiosHttp,
        "plans/" + this.selectedPlan.Id + "/member-files",
        headers
      );
    },
    async downloadFiles() {
      this.loadingFile = true;
      const ids = mapFileSegmentIds(this.checkedFiles);
      try {
        const res = (await this.downloadFile({ ids: ids })).data;
        // const blob = window.URL.createObjectURL(
        //   new Blob([base64ToArrayBuffer(res)])
        // );
        const blob = this.b64toBlob(res);
        const name =
          ids.length > 1
            ? "files.zip"
            : this.checkedFiles[0].FileSegments[0].FileName;
        saveAs(blob, name);
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingFile = false;
      }
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    async deleteItems() {
      const options = {
        planIdentityId: this.selectedPlan.Id,
        payload: { Ids: this.checkedFiles.map((o) => o.Id) },
      };
      try {
        this.saving = true;
        await this.deleteMemberFiles(options);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.deleteDialog = false;
        this.$refs.table.getDataAsync();
      }
    },
  },
};
</script>
